import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ChannelIcon, channelNameMap } from "../../../../../../../channels/components/channel-icon";
import { NotSet } from "../../components/not-set";
import { usePreviewContext } from "../../preview-context";

export const PreviewDetailsSidebarPlatform: FC = () => {
  const {
    moment_preview_data: { channel },
  } = usePreviewContext();

  return (
    <Stack direction="column" spacing={1}>
      {!channel && <NotSet />}
      {channel && (
        <Stack direction="row" spacing={1} alignItems="center">
          <ChannelIcon channel={channel} fontSize="medium" />
          <Typography variant="body2">{channelNameMap(channel)}</Typography>
        </Stack>
      )}
    </Stack>
  );
};
